module.exports = __webpack_public_path__ + "static/img/icon_tp_hover.79ee8854.svg";